import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import branding from 'shared/app/model/branding';
import { ConfigHistory } from 'z3k-settings/components/history-z3k-config/config-history';
import { Z3KSettings } from 'z3k-settings/provider/types';
import { ProPaper } from 'console/account/popup-for-pro';
import { getTariffProName } from 'console/billing/account-tariff/utils';
import { Box, Typography } from '@mui/material';
import { useShowPaidOptionsWithBalance } from 'console/billing/billing-utils';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { can_use_config_history } from 'console/account/account_tsx';
import { z3k_config_history_selector } from 'console/device-settings/z3k/components/history-z3k-config/config-history';
import { simple_plural } from 'utils';
export function HistoryZ3KConfig() {
    const { device_id, is_staff } = useContext(Z3KSettings);
    const can_user_config_history = useAppSelector(can_use_config_history);
    const is_user_pro = can_user_config_history || is_staff;
    const show_paid_options = useShowPaidOptionsWithBalance();
    const history_configs = useAppSelector(z3k_config_history_selector);
    const saveCount = history_configs.filter((config) => config.save).length;
    return (_jsx(Box, { display: "flex", flexDirection: "column", mt: 2, children: !is_user_pro && show_paid_options ? (_jsx(ProPaper, { text: `История конфигураций доступна в тарифе ${getTariffProName()}!
                    Без тарифа восстановить конфигурацию можно через обращение в техническую поддержку.` })) : (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h6", color: "secondary.main", sx: { ml: '15px' }, children: "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0439" }), _jsx(Typography, { variant: "body2", color: "text.secondary", sx: { ml: '15px' }, children: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E 50 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0445 \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0439." }), _jsx(Typography, { variant: "body2", color: "text.secondary", sx: { ml: '15px', mt: 1 }, children: getSaveConfigsText(saveCount) }), _jsx(ConfigHistory, { device_id: device_id, show_anyway: is_staff })] })) }));
}
HistoryZ3KConfig.isWarning = () => false;
HistoryZ3KConfig.isError = () => {
    return false;
};
HistoryZ3KConfig.isShown = (is_service_view, config, spec, is_staff, is_climatic) => {
    return (!Z3K_IS_USB_UTILITY &&
        branding.enable_zont_billing &&
        branding.show_pro_requisition &&
        is_staff &&
        !is_climatic);
};
function getSaveConfigsText(saveCount) {
    if (saveCount === 0) {
        return 'Нет закрепленных конфигураций. Возможно закрепить 3. Закрепленные конфигурации не удаляются из базы.';
    }
    else {
        return `Закреплено: ${saveCount} ${simple_plural(saveCount, 'конфигурация', 'кофигурации')} из 3.`;
    }
}
